import React from "react";
import Card from "components/card";
import { DEPARTMENT_COLORS } from "variables/constants";

const MessageCard = ({
    initial,
    selected = false,
    department,
    status,
    priority,
    time,
    title,
    messagePreview,
    onClick,
}) => {

    const deptColors = DEPARTMENT_COLORS[department] || { bg: "bg-gray-100", icon: "text-gray-600" };

    return (
        <Card 
            onClick={onClick}
            className={`text-slate-900 flex flex-col gap-6 rounded-xl cursor-pointer transition-all duration-300 hover:shadow-md overflow-hidden ${
                selected 
                    ? "border-2 border-emerald-500 bg-gradient-to-br from-emerald-50 to-green-50"
                    : "border border-slate-200 bg-white"
            }`}
        >
            <div className="pb-6 p-3">
                <div className="flex items-start gap-2.5">
                    <span className={`relative items-center justify-center flex size-full shrink-0 overflow-hidden rounded-full w-9 h-9 border-2 border-white shadow-sm text-[11px] font-semibold ${
                            selected
                                ? "bg-gradient-to-br from-emerald-500 to-green-500 text-white"
                                : `${deptColors.bg} ${deptColors.icon}`
                        }`}
                    >
                        {initial}
                    </span>
                    <div className="flex-1 overflow-hidden">
                        <div className="flex items-start justify-between gap-2 mb-1">
                            <div className="flex-1 overflow-hidden pr-1">
                                <p className="text-[12px] font-semibold break-words">
                                    {department}
                                </p>
                                <p className="text-[11px] break-words font-medium">
                                    {title}
                                </p>
                            </div>
                        </div>
                        <p className="text-[10px] text-slate-700 line-clamp-2 mb-2 break-words">
                            {messagePreview}
                        </p>
                        <div className="flex items-center justify-between flex-wrap gap-1.5">
                            <div className="flex items-center gap-1.5 flex-wrap">
                                <span className={`status-indicator ${priority.toLowerCase()} text-[9px]`}>
                                    {priority}
                                </span>
                                <span className={`status-indicator ${status.toLowerCase().replace(/\s+/g, "-")} text-[9px]`}>
                                    {status}
                                </span>
                            </div>
                            <span className="text-[9px] text-slate-700 whitespace-nowrap">
                                {time}
                            </span>
                        </div>
                    </div>
                </div>
            </div>  
        </Card>
    )
};
export default MessageCard;